class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.shopify-section-header');
    this.header.classList.add('shopify-section-header-sticky');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  disconnectedCallback() {}

  onScroll() {}

  hide() {}

  reveal() {}

  reset() {}

  closeMenuDisclosure() {
    this.disclosures =
      this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach((disclosure) => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal =
      this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);

class StaticHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.shopify-section-header');
    this.header.classList.add('shopify-section-header--relative');
  }
}

customElements.define('static-header', StaticHeader);

// Cache DOM elements to avoid repeated queries
let headerElement = null;
let announcementBarElement = null;
let headerMegaMenus = null;
let headerDropdownMenus = null;

// Initialize cached DOM elements early
function initializeDOMCache() {
  headerElement = document.querySelector('.header-wrapper');
  announcementBarElement = document.querySelector('.announcement-bar');
  headerMegaMenus = document.querySelectorAll('.header__mega-menu');
  headerDropdownMenus = document.querySelectorAll('.header__dropdown-menu');
}

function initializeHeaderPosition() {
  headerMegaMenus?.forEach((menuList) => {
    setHeaderOverflow(menuList)
  });

  headerDropdownMenus?.forEach((menuList) => {
    setHeaderOverflow(menuList);
  });
}

function setHeaderOverflow(menuList) {
  if (!window.navigationSize || typeof window.navigationSize.navOffsetStart === 'undefined') {
    return;
  }

  const menuHeight = menuList.scrollHeight;
  const headerOffset = window.navigationSize.navOffsetStart;

  if (menuList && window.innerHeight < menuHeight + headerOffset) {
    menuList.style.overflowY = 'auto';
  } else if (menuList) {
    menuList.style.overflowY = 'hidden';
  }
}

document.addEventListener('navigationSizeUpdated', initializeHeaderPosition);

function initializeUpdateNavigationSize() {
  // Elements are already cached, just proceed with setup
  // Use ResizeObserver if available, otherwise fallback to resize events
  if ('ResizeObserver' in window) {
    observeNavigationElements();
    // Also add resize event listener for cases ResizeObserver might miss
    window.addEventListener('resize', window.debounce(updateNavigationSize, 100));
  } else {
    updateNavigationSize();
    window.addEventListener('resize', window.debounce(updateNavigationSize, 100));
  }
}

function updateNavigationSize() {
  if (updateNavigationSize.isUpdating) return;
  updateNavigationSize.isUpdating = true;

  requestAnimationFrame(() => {
    const floatingContainer = document.querySelector('.header-floating-container');
    const floatingPadding = floatingContainer
      ? parseFloat(getComputedStyle(floatingContainer).paddingTop) || 0
      : 0;
    const headerHeight = (headerElement?.offsetHeight || 0) + floatingPadding;
    const announcementBarHeight = announcementBarElement?.offsetHeight || 0;
    const navOffsetStart = headerHeight + announcementBarHeight;

    // Update global state
    window.navigationSize = {
      headerHeight,
      announcementBarHeight,
      navOffsetStart,
    };

    // Set CSS custom properties
    const docEl = document.documentElement.style;
    docEl.setProperty('--header-height', `${headerHeight}px`);
    docEl.setProperty('--announcement-bar-height', `${announcementBarHeight}px`);
    docEl.setProperty('--nav-offset-start', `${navOffsetStart}px`);

    // Dispatch update event
    document.dispatchEvent(new CustomEvent('navigationSizeUpdated', {
      detail: {
        headerHeight,
        announcementBarHeight,
        navOffsetStart,
        isUpdated: true,
      },
    }));

    updateNavigationSize.isUpdating = false;
  });
}

function observeNavigationElements() {
  const elements = [headerElement, announcementBarElement].filter(Boolean);

  if (elements.length === 0) return;

  const resizeObserver = new ResizeObserver(() => {
    updateNavigationSize();
  });

  elements.forEach(element => resizeObserver.observe(element));

  // Initial calculation
  updateNavigationSize();
}

// Initialize DOM cache and setup when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  initializeDOMCache();
  initializeUpdateNavigationSize();
});

// Update on window load for more accurate measurements
window.addEventListener('load', updateNavigationSize);
